import { render, staticRenderFns } from "./EditCommodityModal.vue?vue&type=template&id=a77e5c8c"
import script from "./EditCommodityModal.vue?vue&type=script&lang=ts"
export * from "./EditCommodityModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports